import type { AggregationColor } from 'antd/es/color-picker/color';

/**
 * Serialize a color picked in the AntD ColorPicker for persistence as the starter `markerColor`.
 * Opaque colors stay 6-digit (`#RRGGBB`) for back-compat; colors with transparency are emitted as
 * 8-digit hex (`#RRGGBBAA`) so the user-selected alpha survives the round-trip. tinycolor2 (1.6.0)
 * has no `toHex8String`, so the alpha byte is appended manually.
 */
export function markerColorToString(color: AggregationColor): string {
  const { r, g, b, a } = color.toRgb();
  const h = (n: number) => Math.round(n).toString(16).padStart(2, '0');
  const rgb = `#${h(r)}${h(g)}${h(b)}`;
  return a >= 1 ? rgb : `${rgb}${h(a * 255)}`;
}
